<div class="flex align-items-center justify-content-center">
  <div class="surface-card p-3 sm:p-4 shadow-2 border-round w-full lg:w-6">
    @if (!mfaRequired()) {
      <!-- Header Section -->
      <div class="text-center mb-3 sm:mb-5">
        <img [src]="themeService.logoPath()" alt="Sequal App Logo" height="50" class="mb-2 sm:mb-3" />
        <div class="text-900 text-3xl font-medium mb-2 sm:mb-3">
          Welcome To Sequal App
        </div>
        <div class="text-600 font-medium mb-2 sm:mb-3">{{ tagline }}</div>
        @if (isRegistrationAllowed) {
          <div data-testid="signup-section">
            <span class="text-600 font-medium line-height-3">Don't have an account?</span>
            <a (click)="navigateToSignUp()" class="font-medium no-underline ml-2 text-blue-500 cursor-pointer">Create
            today!</a>
          </div>
        }
      </div>
      <!-- Login Form -->
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <!-- Email Field -->
        <div class="mb-2 sm:mb-3">
          <label for="email" class="block text-900 font-medium mb-2">Email</label>
          <input id="email" type="email" placeholder="Email address" pInputText formControlName="email"
            autocomplete="username" class="w-full mb-2 sm:mb-3" />
          @if (
            loginForm.get('email')?.invalid && loginForm.get('email')?.touched
            ) {
            <small class="p-error">
              Invalid email
            </small>
          }
        </div>
        <!-- Password Field -->
        <div class="mb-2 sm:mb-3">
          <label for="password" class="block text-900 font-medium mb-2">Password</label>
          <p-password id="password" placeholder="Password" [feedback]="false" [toggleMask]="true"
            formControlName="password" autocomplete="current-password" styleClass="w-full" [style]="{ width: '100%' }"
          [inputStyle]="{ width: '100%' }"></p-password>
          @if (
            loginForm.get('password')?.invalid &&
            loginForm.get('password')?.touched
            ) {
            <small class="p-error">
              Password is required
            </small>
          }
        </div>
        <!-- Remember Me & Forgot Password -->
        <div class="flex align-items-center justify-content-between mb-4 sm:mb-6">
          <a (click)="navigateToForgotPassword()"
            class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">
            Forgot password?
          </a>
        </div>
        <!-- Captcha -->
        @if (isCaptchaRequired()) {
          <div class="mb-3 sm:mb-4">
            <app-captcha />
          </div>
        }
        <!-- Error Message — above the button, next to the fields it is about. -->
        @if (loginFailed()) {
          <p class="p-error mt-2 sm:mt-3" role="alert" aria-live="assertive">
            Invalid credentials, please try again.
          </p>
        }
        <!-- Login Button -->
        <button pButton pRipple label="Sign In" icon="pi pi-user" class="w-full"
          [disabled]="loginForm.invalid || isSigningIn()" [loading]="isSigningIn()"></button>
      </form>
    }

    <!-- MFA Verification Form -->
    @if (mfaRequired()) {
      <div>
        <div class="text-center mb-3 sm:mb-5">
          <img [src]="themeService.logoPath()" alt="Sequal App Logo" height="50" class="mb-2 sm:mb-3" />
          <div class="text-900 text-3xl font-medium mb-2 sm:mb-3">
            Verify Your Identity
          </div>
          <span class="text-600 font-medium line-height-3">
            {{ useBackupCode() ? 'Enter one of your backup codes.' : 'Enter the code from your authenticator app.' }}
          </span>
        </div>
        <form [formGroup]="mfaForm" (ngSubmit)="onVerifyMfa()">
          @if (!useBackupCode()) {
            <div class="mb-2 sm:mb-3">
              <label for="totpCode" class="block text-900 font-medium mb-2">Authenticator Code</label>
              <input id="totpCode" type="text" placeholder="6-digit code" pInputText formControlName="totpCode"
                class="w-full mb-2 sm:mb-3" maxlength="6" />
              @if (mfaForm.get('totpCode')?.invalid && mfaForm.get('totpCode')?.touched) {
                <small class="p-error">
                  Please enter a valid 6-digit authenticator code.
                </small>
              }
            </div>
          } @else {
            <div class="mb-2 sm:mb-3">
              <label for="backupCode" class="block text-900 font-medium mb-2">Backup Code</label>
              <input id="backupCode" type="text" placeholder="XXXXX-XXXXX" pInputText [(ngModel)]="backupCode"
                [ngModelOptions]="{ standalone: true }" class="w-full mb-2 sm:mb-3" autocomplete="one-time-code" />
            </div>
          }
          <div class="flex flex-column gap-2">
            <button pButton pRipple label="Verify" icon="pi pi-check" class="w-full"
            [disabled]="(!useBackupCode() && mfaForm.invalid) || isVerifyingMfa()" [loading]="isVerifyingMfa()"></button>
            <button pButton pRipple type="button" label="Cancel" icon="pi pi-times" class="w-full" severity="secondary"
            (click)="cancelMfa()"></button>
          </div>
          <!-- Backup code / authenticator toggle -->
          <div class="text-center mt-3">
            <a (click)="toggleBackupCode()" class="font-medium no-underline text-blue-500 cursor-pointer">
              {{ useBackupCode() ? 'Use authenticator code instead' : 'Use a backup code instead' }}
            </a>
          </div>
          <!-- Lost Authenticator Link -->
          <div class="text-center mt-3">
            <a (click)="navigateToLostAuthenticator()" class="font-medium no-underline text-blue-500 cursor-pointer">
              Lost your authenticator?
            </a>
          </div>
        </form>
      </div>
    }
  </div>
</div>